import request from '@/utils/request';

/**删除入库单 */
export const deleteInstock = (id: string) => {
  return request.del(`/api/Stock/${id}`);
};

/**获取入库单 */
export const getInstock = (id: string) => {
  return request.get(`/api/Stock/${id}`);
};

/**新增，修改入库单 */
export const createOrEditInstock = (form: any) => {
  return request.post(`/api/Stock/CreateOrEdit`, form);
};
/**获取仓库 */
export const getStockWarehouses = () => {
  return request.get(`/api/Stock/Warehouses`);
};

/**获取操作记录 */
export const getStockLog = (id: string) => {
  return request.get(`/api/Stock/${id}/logs`);
};

/**审核入库单 */
export const approveStock = (id: string, form: any) => {
  return request.put(`/api/Stock/${id}/approve`, form);
};

/**导出出入库明细 */
export const exportStockDetail = (form: any) => {
  return request.download(`/api/Stock/Products/List`, { ...form });
};

/**修改商品有效期 */
export const updateProductionDate = (id: string, form: any) => {
  return request.put(`/api/Stock/productionDateList/${id}`, { ...form });
};
